import AddressesList from '@/component/addresses/AddressesList';
import CreateAddress from '@/component/addresses/CreateAddress';
import Header from '@/component/Header';
import { Box, Card, CardContent, Typography } from '@mui/material';

export default function Addresses() {
  return (
    <Box
      sx={{
        display: 'flex',
        overflow: 'auto',
        flex: 1,
        flexDirection: 'column',
        gap: { xs: '16px', sm: '0px' },
      }}
    >
      <Card>
        <Header title={'지갑 등록 및 리스트'} />
        <CardContent>
          <Typography variant="h6">관리자 지갑 등록</Typography>
          <CreateAddress />
          <Box mb={10} />
          <Typography variant="h6">관리자 지갑 리스트</Typography>
          <AddressesList />
        </CardContent>
      </Card>
    </Box>
  );
}
